import React from "react";
import Header from "../../components/home/header/Header";
import SearchForm from "../../components/search/SearchForm";
// import Footer from "../../components/footer/Footer";

const Search = () => {
  return (
    <>
      <Header />
      <SearchForm />
      {/* <Footer /> */}
    </>
  );
};

export default Search;
